import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Form } from 'antd';
import { Button } from 'ui';
import { StyledNotificationDrawer } from './style';
import TabbedSettings from 'admin/components/NotificationsSettings/TabbedSettings';
import type { PrefMap } from 'admin/components/NotificationsSettings/types';
import type { FarmSearchFilterMap } from 'admin/components/FarmSearchFilterSettings/types';

const DRAWER_WIDTH = 923;

type Tab = 'user' | 'farm';

interface DrawerNotificationPreferencesProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (data?: Record<string, boolean>) => void;
  width?: number;
}

function DrawerNotificationPreferences({
  open,
  onClose,
  onSaved,
  width = DRAWER_WIDTH,
}: DrawerNotificationPreferencesProps) {
  const intl = useIntl();
  const [userForm] = Form.useForm<PrefMap>();
  const [farmForm] = Form.useForm<FarmSearchFilterMap>();

  const [activeTab, setActiveTab] = useState<Tab>('user');
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (activeTab === 'user') {
      userForm.submit();
    } else {
      farmForm.submit();
    }
  };

  return (
    <StyledNotificationDrawer
      open={open}
      onClose={onClose}
      width={width}
      destroyOnClose
      title={intl.formatMessage({ id: 'notification.preferences.title' })}
      zIndex={1100}
      footer={
        <div className="drawer-footer">
          <Button
            type="primary"
            label={intl.formatMessage({ id: 'general.save' })}
            onClick={handleSave}
            disabled={!dirty || saving}
            loading={saving}
          />
          <Button
            label={intl.formatMessage({ id: 'general.close' })}
            onClick={onClose}
            disabled={saving}
          />
        </div>
      }
    >
      <TabbedSettings
        userForm={userForm}
        farmForm={farmForm}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onSaved={onSaved}
        onDirtyChange={setDirty}
        onSavingChange={setSaving}
      />
    </StyledNotificationDrawer>
  );
}

export default DrawerNotificationPreferences;
